import { render, staticRenderFns } from "./Incentives.vue?vue&type=template&id=2dfd1804&"
import script from "./Incentives.vue?vue&type=script&lang=js&"
export * from "./Incentives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports